import { post } from '@mindtickle/api-helpers';

interface ProfileStatusParams {
  sessionId: string;
  userId: string;
}

interface ProfileStatusResponse {
  data: {
    user: {
      isUserProfileComplete: boolean;
    };
  };
  errors?: Array<any>;
}

export const fetchProfileCompleteStatus = async ({
  sessionId,
  userId,
}: ProfileStatusParams): Promise<boolean> => {
  try {
    const {
      data: {
        user: { isUserProfileComplete },
      },
      errors,
    }: ProfileStatusResponse = await post(
      {
        url: `${process.env.UMG_GQL_BASE_PATH}/graphql`,
      },
      {
        headers: {
          'x-token': sessionId,
        },
        body: {
          query: `query ($userId: String!) {
            user {
             isUserProfileComplete( userId: $userId )
           }
         }`,
          variables: {
            userId,
          },
        },
      }
    );
    return (!errors || errors.length <= 0) && isUserProfileComplete;
  } catch (errors) {
    console.error(errors); // eslint-disable-line
    return true;
  }
};
